import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { ICDDiagnose } from 'app/_models/icd-diagnose.model';
import { CommonService } from "app/reusable/common.service";
import { environment } from "environments/environment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CedNotificationService } from "ced-ng-library";

@Component({
  selector: 'app-add-icd-diagnose',
  templateUrl: './add-icd-diagnose.component.html',
  styleUrls: ['./add-icd-diagnose.component.scss']
})
export class AddIcdDiagnoseComponent implements OnInit, OnDestroy {
  modId: string = this.activeRoute.snapshot.paramMap.get("modId");
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;
  @Output() Change: EventEmitter<{
    dialogstatus;
    icdDiagnose;
  }> = new EventEmitter();
  AddDialogOpened = false;
  public ICDDiagnoseForm: FormGroup;
  public icdDiagnose = new ICDDiagnose();
  @Input() gridData = [];
  existingCode: boolean = false;
  private subject$ = new Subject();

  constructor(
    private commonService: CommonService,
    private activeRoute: ActivatedRoute,
    private cedNotificationService: CedNotificationService
    ) { 
      
    }

  ngOnInit() {
    this.ICDDiagnoseForm = new FormGroup({
      icdCode: new FormControl("", Validators.required),
      icdName: new FormControl("", Validators.required),
      icdIsActive: new FormControl(false),
      icdComment: new FormControl("")
    });
    this.ICDDiagnoseForm.patchValue(this.icdDiagnose);
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.ICDDiagnoseForm.controls[controlName].hasError(errorName);
  };

  public CreateicdDiagnose = (ICDDiagnoseFormValue) => {
    
    this.checkCode(this.ICDDiagnoseForm.controls['icdCode'].value, ICDDiagnoseFormValue); 
  };

   checkCode(code:string, ICDDiagnoseFormValue){
    let getByCodeUrl: string = `IcdDiagnose/GetByCode/`+code;
    this.commonService.getData(getByCodeUrl, this.serverUrlSlot3).pipe(takeUntil(this.subject$))
      .subscribe((data: any) => {
        this.existingCode = (data != null || this.gridData.filter(e=>e.icdCode == code).length > 0);

        if(this.existingCode){
          this.cedNotificationService.error("NOTIFICATIONS.ICD_CODE_SHOULD_BE_UNIQUE")      
        }
        else if (this.ICDDiagnoseForm.valid) {
          this.ExecuteicdDiagnoseCreation(ICDDiagnoseFormValue);
        }
      });
  }

  private ExecuteicdDiagnoseCreation = (ICDDiagnoseFormValue) => {
    this.icdDiagnose.icdCode = ICDDiagnoseFormValue.icdCode;
    this.icdDiagnose.icdName = ICDDiagnoseFormValue.icdName;
    this.icdDiagnose.icdIsActive = ICDDiagnoseFormValue.icdIsActive;
    this.icdDiagnose.icdComment = ICDDiagnoseFormValue.icdComment;
    this.icdDiagnose.icdMidOfficeDiagnoseId = this.modId;
    this.Change.emit({
      icdDiagnose: this.icdDiagnose,
      dialogstatus: this.AddDialogOpened,
    });
  };

  public Cancel() {
    this.Change.emit({ dialogstatus: this.AddDialogOpened, icdDiagnose: "" });
  }

  ngOnDestroy(): void {
    this.subject$.unsubscribe();
  }
}
